import { Injectable } from '@angular/core';
import { safeMap } from '@era/stores';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleDevicesService } from '@rocksoft/mdm-sdk-v2';
import { filter, map, mergeMap } from 'rxjs/operators';
import { AppleDeviceApiActions, DeviceLocationResolverActions } from './device-location.actions';

@Injectable()
export class DeviceLocationEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleDeviceService: AppleDevicesService
  ) {}

  deviceLocationRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(DeviceLocationResolverActions.deviceLocationRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDeviceService.getLocation(udid, '2.0').pipe(
            filter((location) => location !== null),
            map((location) => ({
              ...location,
              udid: udid,
            }))
          ),
          (deviceLocation) => AppleDeviceApiActions.deviceLocationLoaded({ deviceLocation }),
          (error) => AppleDeviceApiActions.deviceLocationLoadedError({ error })
        )
      )
    );
  });
}
